import { connect } from 'react-redux';
import { Locales } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
import { withChartLayout } from 'components/common';
import EmergencyDepartment from 'components/features/chart/special-charts/emergency-department/EmergencyDepartment';

const EmergencyDepartmentContent = withChartLayout('Emergency Department')(EmergencyDepartment);

export interface EmergencyDepartmentPageProps {
  isSimulationEHREnabled: boolean;
  locale: Locales;
}

export const BaseEmergencyDepartmentPage = ({ isSimulationEHREnabled, locale }: EmergencyDepartmentPageProps) =>
  isSimulationEHREnabled && locale !== Locales.EN_AU ? <EmergencyDepartmentContent /> : null;

const mapStateToProps = (state) => ({
  isSimulationEHREnabled: appSelectors.getIsSimulationEHREnabled(state),
  locale: appSelectors.getLocale(state)
});

export default connect(mapStateToProps)(BaseEmergencyDepartmentPage);
